<script setup lang="ts">
import { useElementSize } from '@vueuse/core';

const props = defineProps<{
  steps: number;
  currentStep: number;
  isLastStep: boolean;
  userName: string;
}>();

const stepProgressEl = ref<HTMLDivElement | null>(null);

const { width: stepProgressWidth } = useElementSize(stepProgressEl);

const progressLineWidth = computed(() => {
  return stepProgressWidth.value / (props.steps - 1) - 12 + 'px';
});
</script>

<template>
  <div :class="$style.progressComponent">
    <div
      ref="stepProgressEl"
      :class="$style.stepProgress"
    >
      <div
        v-for="step in steps"
        :key="step"
        :class="[
          $style.step,
          [step === currentStep ? 'bg-primary' : 'bg-white'],
        ]"
      >
        <NuxtIcon
          v-if="step < currentStep"
          class="h-full m-auto text-success items-center flex"
          name="check"
        />
        <NuxtIcon
          v-else-if="step === steps"
          name="gift"
        />
        <span v-else>
          {{ step }}
        </span>
      </div>
    </div>
    <section :class="$style.textSection">
      <p>{{
        $t(`multiStepRegister.step${props.currentStep}.title`, {
          name: userName,
        })
      }}</p>
      <p>{{ $t(`multiStepRegister.step${props.currentStep}.desc`) }}</p>
    </section>
  </div>
</template>

<style module lang="scss">
.progressComponent {
  @apply bg-black/20 mb-2 sm:mb-4 p-3 sm:p-4 rounded-lg w-full;

  .stepProgress {
    @apply flex justify-between w-full;

    .step {
      @apply relative w-6 h-6 flex items-center justify-center rounded-full font-black text-center text-xs;
    }

    .step:not(:last-child):after {
      @apply absolute content-[''] top-1/2 left-full w-full h-0.5 bg-white;
      width: v-bind(progressLineWidth);
    }
  }

  .textSection {
    @apply mt-2 sm:mt-4 text-white text-2xs sm:text-xs block;

    h1 {
      @apply font-bold;
    }

    p {
      @apply text-white/70;
    }
  }
}
</style>
